import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selectedDateBlockIndex: '',
    sessionStatus: '',
    localAppointment: {},
    GLOBALS: [],
    perms: null,
    endpoint: null,
    otpCount: 0,
    confirmationCode: "",
  },
  mutations: {
    setLocalAppointment(state, appointment){
      for (let key in appointment){
        let val = appointment[key]
        if(key === 'metadata'){
          val = JSON.stringify(val)
        }
        // if(key === 'scheduledForTime' || key === 'isValid'){
        //   continue
        // }
        localStorage.setItem(key, val)
      }
      state.localAppointment = appointment
    },
    setSessionStatus(state, sessionStatus){
      localStorage.setItem('sessionStatus', sessionStatus)
      state.sessionStatus = sessionStatus
    },
    incrementOtpCount(state){
      state.otpCount += 1
      localStorage.setItem('otpCount', state.otpCount)
    },
    resetOtpCount(state){
      state.otpCount = 0
      localStorage.setItem('otpCount', state.otpCount)
    },
    setSelectedDateBlockIndex(state, selectedDateBlockIndex){
      if(selectedDateBlockIndex === 0) selectedDateBlockIndex = "0"
      localStorage.setItem('selectedDateBlockIndex', selectedDateBlockIndex)
      state.selectedDateBlockIndex = selectedDateBlockIndex
    },
    resetSelectedDateBlockIndex(state){
      state.selectedDateBlockIndex = ""
      localStorage.setItem('selectedDateBlockIndex', state.selectedDateBlockIndex)
    },
    resetConfirmationCode(state){
      state.confirmationCode = ""
      localStorage.setItem('confirmationCode', state.confirmationCode)
    },
    clearSessionStatus(state){
      state.sessionStatus = ''
      localStorage.removeItem('sessionStatus')
    },
    setEndpoint(state, endpoint){
      state.endpoint = endpoint;
    },
    setConfirmationCode(state, code){
      state.confirmationCode = code;
    },
    robStore(state){
      for (let key in state.appointment){
        localStorage.removeItem(key)
      }
      state.localAppointment = null
      state.localAppointment = {}
      localStorage.removeItem('sessionStatus')
      localStorage.removeItem('selectedDateBlockIndex')
      localStorage.removeItem('otpCount')
      localStorage.removeItem('confirmationCode')
    },
    initialiseStore(state) {
      let obj = {
        budget: '',
        customerCity: '',
        customerEmail: '',
        customerLine1: '',
        customerLine2: '',
        customerName: '',
        customerPhone: '',
        exemptionLabel: '',
        gender: 0,
        intentions: [],
        isLoading: false,
        isValid: false,
        metadata: {},
        occupants: '',
        scheduledFor: '',
        scheduledForDate: '',
        weddingDate: ''
        
      }
      for(let item in obj){
        if (localStorage.getItem(item)) {
          obj[item] = localStorage.getItem(item);
          if(item === 'metadata'){
            obj[item] = JSON.parse(obj[item])
          }
        }
      }
      
      if(obj.intentions  && obj.intentions.length > 0)
        obj.intentions = obj.intentions.replace("[","").replace("]", "").split(",").map(x=>parseInt(x))


      state.appointment = obj

      if(localStorage.getItem('sessionStatus')){
        state.sessionStatus = localStorage.getItem('sessionStatus')
      }

      if(localStorage.getItem('selectedDateBlockIndex')){
        state.selectedDateBlockIndex = localStorage.getItem('selectedDateBlockIndex')
      }

      if(localStorage.getItem('otpCount')){
        state.otpCount = parseInt(localStorage.getItem('otpCount'))
      }

      if(localStorage.getItem('confirmationCode')){
        state.confirmationCode = parseInt(localStorage.getItem('confirmationCode'))
      }

    },
    setGLOBALS(state, val){
      state.GLOBALS = val;
      console.log("VUEX: ✅ DB Globals Set.")
    },
  },
  actions: {
  },
  modules: {
  },
  getters: {
    getConfirmationCode: state => state.confirmationCode,
    getOtpCount: state => state.otpCount,
    getSelectedDateBlockIndex: state => state.selectedDateBlockIndex,
    getSessionStatus: state => state.sessionStatus,
    getLocalAppointment: state => state.appointment,
    getEndpoint: state => state.endpoint,
    getWorkingId: state => state.workingId,
    getPerms: state => state.perms,
    getUserCache: state => state.userCache,
    menuItems: (state, getters) => {
      let ret = []
      state.menuItems.forEach(item=>{
        if(!item.protected) ret.push(item)
        else {
          if(item.text == 'Reports' && getters.isAllowed('user', 'reports'))
            ret.push(item)
          else if(item.text == 'User Management' && getters.isAllowed('user', 'manage'))
            ret.push(item)
          else if(item.text == 'Super Admin' && state.user.userTypeId===1) // Super Admins are always id 1
            ret.push(item)
          else if(item.text == 'Devices' && state.user.userTypeId===1) // Super Admins are always id 1
            ret.push(item)
        }
      })
      return ret
    },
    lookupUsername: (state) => (id) =>{
      if(!id) return null
      let y = state.userCache.find(x=>x.id==id)
      if(!y) return null
      return y.firstName + ' ' + y.lastName
    },
    getBranch: state => state.user?.metadata?.branchData?.main,
    getBranches: state => state.branches,
    getAllowedBranches: state => state.allowedBranches,
    lookupBranch: (state) => (id) =>{
      if(!id) return null
      let y = state.branches.find(x=>x.id==id)
      if(!y) return null
      return y.name;
    },
    getUser: state => state.user,
    isLoggedIn: state => state.id ? true : false,
    globalQueryBcAllowed: (state)=>{
      return state.globalQueryBc
    },
    isAllowed: (state) => (resource, requiredPerm) => {
      if(!resource) return false
      if(!requiredPerm) return false
      if(!state.perms) return false
      return (state.perms.permissions[resource])[requiredPerm]
    },
    getRole: state => state.perms?.description,
    nowServing: state => state.sIDAuthorizer.nowServing,
    scanBus: state => state.scanBus,
    isManaged: state => state.isManaged,
    getGlobalValue: (state) => (key) => (state.GLOBALS.find(x=>x.key==key))?.value,
  }
})
